import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { EstateTaskProfessionStatus } from '/@/modules/estatetask/enums/EstateTaskProfessionStatus';
import { EstateTaskTaxFormStatus } from '/@/modules/estatetask/enums/EstateTaskTaxFormStatus';
import { EstateTaskEstateFormTemplateStatus } from '/@/modules/estatetask/enums/EstateTaskEstateFormTemplateStatus';
import { EstateTaskUserStatus } from '/@/modules/estatetask/enums/EstateTaskUserStatus';

export default class EstateTaskStatusFactory {
  /**
   *
   * @param modelType
   * @returns {Enum}
   */
  static build(modelType) {
    if (modelType === ModelType.PROFESSION) {
      return EstateTaskProfessionStatus;
    }

    if (modelType === ModelType.ESTATE_TAX_FORM) {
      return EstateTaskTaxFormStatus;
    }

    if (modelType === ModelType.ESTATE_FORM_TEMPLATE) {
      return EstateTaskEstateFormTemplateStatus;
    }

    if (modelType === null) {
      return EstateTaskUserStatus;
    }

    return null;
  }
}
